import React from 'react';

 class EventHyperlinkRenderer extends React.Component {
    constructor(props) {
        super(props);
        
      }
    
      render() {
        return (
            <a href={this.props.data.eventUrl} target="_blank">{this.props.data.ticketId}</a>                
        )
      } 
    }
    export default EventHyperlinkRenderer;